/*!
 * devextreme-angular
 * Version: 26.1.5
 * Build date: Fri Sep 11 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-data-grid-group-operation-descriptions',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoDataGridGroupOperationDescriptionsComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get and(): string {
        return this._getOption('and');
    }
    set and(value: string) {
        this._setOption('and', value);
    }

    @Input()
    get notAnd(): string {
        return this._getOption('notAnd');
    }
    set notAnd(value: string) {
        this._setOption('notAnd', value);
    }

    @Input()
    get notOr(): string {
        return this._getOption('notOr');
    }
    set notOr(value: string) {
        this._setOption('notOr', value);
    }

    @Input()
    get or(): string {
        return this._getOption('or');
    }
    set or(value: string) {
        this._setOption('or', value);
    }


    protected get _optionPath() {
        return 'groupOperationDescriptions';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoDataGridGroupOperationDescriptionsComponent
  ],
  exports: [
    DxoDataGridGroupOperationDescriptionsComponent
  ],
})
export class DxoDataGridGroupOperationDescriptionsModule { }
